// extracted by mini-css-extract-plugin
export default {"popover-container":"Popover_popover-container__4MH-n","popover-container__popover":"Popover_popover-container__popover__wAZPX"};